import React from 'react';

import classNames from 'classnames';
import { useTranslation } from '@lt/localization';
import styles from './HotelFAQ.module.css';
import HotelFAQItem from './components/HotelFAQItem/HotelFAQItem';
import { HOTEL_FAQ_HEADER_TEST_ID, HOTEL_FAQ_TEST_ID } from './constants';
import type { HotelFAQProps } from './types';

export const HotelFAQ = ({
  hotelName,
  isMobile,
  questions = [],
}: HotelFAQProps) => {
  const { t } = useTranslation();

  if (!Array.isArray(questions)) return null;

  return (
    <div className={styles.container} data-testid={HOTEL_FAQ_TEST_ID}>
      <div
        className={classNames(styles.containerContent, {
          [styles.mobileContainerContent]: isMobile,
        })}
      >
        <h3
          className={classNames(styles.header, {
            [styles.mobileHeader]: isMobile,
          })}
          data-testid={HOTEL_FAQ_HEADER_TEST_ID}
        >
          {`${t('hotelcard.faq.header')} ${hotelName}`}
        </h3>

        {questions?.map((item) => (
          <HotelFAQItem
            key={item.q}
            title={item.q}
            description={item.a}
            isMobile={isMobile}
          />
        ))}
      </div>

      {/* Для корректной ширины как у отзывов */}
      {!isMobile && <div className={styles.stub} />}
    </div>
  );
};
